export enum BadgeTheme {
  Transparent = 'transparent',
  Gray = 'gray',
}
